import React from "react";

export default function Card(props) {

    const { header = "", style={}, secondary=false, tertiary = false, className = "", onClick = false, onDoubleClick = () => {} } = props;

    let _card_class = (!secondary) ? (tertiary) ? "ui-card tertiary" : "ui-card" : "ui-card secondary";
    let _card_header_class = (!secondary) ? (tertiary) ? "ui-card-header tertiary" : "ui-card-header" : "ui-card-header secondary";
    let _card_content_class = (!secondary) ? (tertiary) ? "ui-card-content tertiary" : "ui-card-content" : "ui-card-content secondary";

    if(className){
        _card_class += " " +className; 
    }

    


    return (
        <div onDoubleClick={onDoubleClick} onClick={() => (onClick) ? onClick() : () => {}} className={_card_class} style={{...style}} >
            
            {(header &&
                <div className={_card_header_class}>
                    {header}
                </div>
            )}

            <div className={_card_content_class}>
                {props.children}
            </div>
        </div>
    )
}